import "../chunk-2WQIUP7O.mjs";
import "../chunk-G445A56D.mjs";
import {
  useGetTeamEvents
} from "../chunk-IKMG7VLI.mjs";
import {
  useGetTeamsList
} from "../chunk-RJH5VMN5.mjs";
import {
  useGetTeam
} from "../chunk-R7GWKXBK.mjs";
import "../chunk-OSOWFQSI.mjs";
import {
  useGetWalletHistory
} from "../chunk-432IDVII.mjs";
import {
  useRechargeWallet
} from "../chunk-BO5PCCIN.mjs";
import {
  useGetTransactionById
} from "../chunk-HURR23GJ.mjs";
import "../chunk-QD2YOJOV.mjs";
import {
  useGetTournamentDetails
} from "../chunk-HTKH7P3K.mjs";
import {
  useGetTournamentEventsBySlug
} from "../chunk-LHOKNCLJ.mjs";
import {
  useGetTournamentOrganizationsBySlug
} from "../chunk-7UTFIZW4.mjs";
import {
  useGetTournamentTeamsBySlug
} from "../chunk-Y5RU64H2.mjs";
import "../chunk-EQMFSDPZ.mjs";
import {
  useAddToThirdPartCart
} from "../chunk-SHTZ7UTX.mjs";
import {
  useInitThirdPartCart
} from "../chunk-2PIRIWGS.mjs";
import {
  useRemoveFromThirdPartCart
} from "../chunk-ZDXAVXFW.mjs";
import "../chunk-O5EKO7IJ.mjs";
import {
  useAnswerSurvey
} from "../chunk-XGZIM7C6.mjs";
import {
  useGetSurvey
} from "../chunk-3WFO4ZMI.mjs";
import "../chunk-5QKEYGOP.mjs";
import {
  useGetVoucherPaymentDetails
} from "../chunk-MDGGWDGE.mjs";
import {
  useGetUserVouchers
} from "../chunk-EVGFRJWK.mjs";
import {
  useGetVouchers
} from "../chunk-EATP2HXG.mjs";
import "../chunk-ODHGRMV4.mjs";
import {
  useCancelSubscription
} from "../chunk-K6SP73FB.mjs";
import {
  useCheckoutStreamWithCredit,
  useCheckoutSubscription
} from "../chunk-KXDKFIBC.mjs";
import {
  useGetSubscriptions
} from "../chunk-ZJRRTZ5V.mjs";
import {
  useGetSubscriptionPlans
} from "../chunk-ESNFBCWK.mjs";
import {
  useGetSubscriptionById,
  useGetUserSubscriptions
} from "../chunk-LU5JBC35.mjs";
import "../chunk-5JSYNTRB.mjs";
import {
  useGetHoldToken
} from "../chunk-CJHMWYF4.mjs";
import "../chunk-5T46NBCZ.mjs";
import {
  useSubscribeSaudiRewards
} from "../chunk-YEVVEGMD.mjs";
import {
  useVerifySaudiRewards
} from "../chunk-UD2ZJBHU.mjs";
import "../chunk-FJWOTG4F.mjs";
import {
  useGetAccessibilitySeason,
  useGetSeason
} from "../chunk-SJICWOGS.mjs";
import {
  useGetSeasonPerks
} from "../chunk-PL5PWLX6.mjs";
import {
  useGetSubscriptionActions
} from "../chunk-22FHLHBU.mjs";
import {
  useGetBillingHistory
} from "../chunk-SXGWJWKH.mjs";
import "../chunk-YHJGQ5NE.mjs";
import {
  useSevenRoomsAvailability
} from "../chunk-ZPPJNU5P.mjs";
import {
  useServmeShifts
} from "../chunk-ZYE7KVKB.mjs";
import {
  useSevenRoomsTables
} from "../chunk-H345BTBB.mjs";
import "../chunk-4SJVSJPB.mjs";
import {
  useRegisterCompetition
} from "../chunk-FB7A63KR.mjs";
import {
  useClaimSaudiRewards
} from "../chunk-UM6CQCXD.mjs";
import "../chunk-PCI3A3DY.mjs";
import {
  useGetPaymentMethods
} from "../chunk-DLFBXC7G.mjs";
import "../chunk-JA5I5RHY.mjs";
import {
  useSendPartnerOtp,
  useVerifyPartnerOtp
} from "../chunk-QLLEPROE.mjs";
import {
  useResetPartnerUserPassword,
  useVerifyPartnerPasswordResetToken
} from "../chunk-HRL7EL2O.mjs";
import {
  useValidatePartnerEnc
} from "../chunk-PYX3MKMM.mjs";
import "../chunk-S2JMW6YP.mjs";
import {
  useSendQitafOtp
} from "../chunk-UPAOBOCC.mjs";
import {
  useRedeemQitaf
} from "../chunk-B2WZZAY3.mjs";
import "../chunk-YMK6WPBI.mjs";
import {
  useGetOrganizationBySlug
} from "../chunk-GHXT6B4X.mjs";
import {
  useGetOrganizations,
  useGetOrganizationsHasVouchers
} from "../chunk-KYTEMKQD.mjs";
import "../chunk-U5RW6XEF.mjs";
import {
  useHoldProducts
} from "../chunk-4LZ4TOXN.mjs";
import {
  useMerchandiseProducts
} from "../chunk-HQWIM5OO.mjs";
import {
  useGetMerchandiseProduct
} from "../chunk-YZRF2UEE.mjs";
import "../chunk-3NAM65ON.mjs";
import {
  useGetTicketingPackage
} from "../chunk-AXMG5WOX.mjs";
import "../chunk-GKZ57MZB.mjs";
import {
  useGetUserFavorites
} from "../chunk-ZWHXVXVY.mjs";
import {
  useGetFavoriteEvent
} from "../chunk-T324GPOT.mjs";
import {
  useGetInterestOptions
} from "../chunk-I4CZNPPH.mjs";
import {
  useUpdateFavoriteTeam
} from "../chunk-WIG7DL2C.mjs";
import {
  useToggleUserFavorite
} from "../chunk-WK4RBPI5.mjs";
import {
  useUpdateUserInterests
} from "../chunk-WDA2SWF5.mjs";
import "../chunk-E6RGKVAL.mjs";
import {
  useRegisterInterest
} from "../chunk-FQ7SQFJ2.mjs";
import {
  useTicketInterest
} from "../chunk-5LB6PMZE.mjs";
import "../chunk-7HR4YN4U.mjs";
import {
  useCheckNafath
} from "../chunk-MZ6XNYQD.mjs";
import {
  useRequestNafath
} from "../chunk-FYHLJFGQ.mjs";
import "../chunk-G7BCRYVW.mjs";
import {
  useSubscribe
} from "../chunk-GVTB7S3K.mjs";
import "../chunk-Z4PLY7ZV.mjs";
import {
  useLocations,
  usePopularLocations
} from "../chunk-URRV7IEC.mjs";
import {
  useGetLocationNotice
} from "../chunk-IWB2CQZL.mjs";
import {
  useGetPackageId,
  useGetPackageResults
} from "../chunk-THMGQ667.mjs";
import {
  useGetHotelReservation,
  useGetHotelReservations
} from "../chunk-2YA5SMC5.mjs";
import {
  useGetHotelsResults
} from "../chunk-ZA2HT7EI.mjs";
import {
  useGetHotelReviews
} from "../chunk-2IARXHUK.mjs";
import {
  useModifySearch,
  useSearchHotels
} from "../chunk-CWVE6FHH.mjs";
import {
  useSelectedPackage
} from "../chunk-HV6I3FYC.mjs";
import {
  useHotelsCheckout
} from "../chunk-UKCJJO2W.mjs";
import {
  useGetHotelDetails,
  useGetRoomDetails
} from "../chunk-MSMY6XPD.mjs";
import {
  useDownloadHotelInvoice
} from "../chunk-TBYFKYMM.mjs";
import "../chunk-2LHFK2NZ.mjs";
import {
  useGeoLocation
} from "../chunk-ER5QWX2V.mjs";
import "../chunk-HDQDOF5J.mjs";
import {
  useCreatePassenger,
  useDeletePassenger,
  useGetAllPassengers,
  useGetPassenger,
  useUpdatePassenger
} from "../chunk-Y2CZ7MVM.mjs";
import {
  useReserveFlight
} from "../chunk-TLGNSPF2.mjs";
import {
  useGetInboundFlights,
  useGetOutboundFlights,
  useSearchFlights
} from "../chunk-C4JGNFDA.mjs";
import {
  useSelectedFlight
} from "../chunk-J3FQGPXW.mjs";
import {
  useAirports,
  useNearestAirport,
  usePopularAirports
} from "../chunk-YEUIC2UF.mjs";
import {
  useFlightsCheckout
} from "../chunk-2KGHTJXT.mjs";
import {
  useFareFamilies
} from "../chunk-VPG5VFDM.mjs";
import {
  useDownloadInvoice
} from "../chunk-74XZQBPZ.mjs";
import {
  useGetFlightOrder,
  useGetFlightsOrders
} from "../chunk-WKVV6HF4.mjs";
import "../chunk-3262HDTK.mjs";
import {
  useGetEventsGroupDetails
} from "../chunk-7IT7PD7K.mjs";
import {
  useEventsList,
  useEventsListByOrganizationSlug,
  usePaginatedEventsList
} from "../chunk-URJLKSRI.mjs";
import {
  useGetEventPerks
} from "../chunk-RV2ILBBG.mjs";
import {
  useGetEventQuestions
} from "../chunk-RVBAJJCM.mjs";
import {
  useGetEventResaleTickets,
  useGetResaleListing
} from "../chunk-S4B2HV3R.mjs";
import {
  useGetTickets
} from "../chunk-43QKBPKD.mjs";
import {
  useGetVenues
} from "../chunk-C6KTUZXO.mjs";
import {
  useGetEventAddonsById
} from "../chunk-YGLIMXYQ.mjs";
import {
  useGetEventCrossSelling
} from "../chunk-I4JJA23W.mjs";
import {
  useGetTicketingEventBlacklist
} from "../chunk-GIQFIQIH.mjs";
import {
  useGetAccessibilityTicketingEvent,
  useGetTicketingEvent
} from "../chunk-ZP55FSGT.mjs";
import {
  useGetEventGroupBySlug
} from "../chunk-DV6PO3DS.mjs";
import {
  useGetUserEventLimits
} from "../chunk-QM6ZMMDK.mjs";
import {
  useGetTicketingEventSlots
} from "../chunk-CRQFNPF6.mjs";
import {
  useGetEventPrerequisiteTickets
} from "../chunk-DKIGNU6F.mjs";
import "../chunk-XUTYQBME.mjs";
import "../chunk-NGR77FSJ.mjs";
import {
  useVerifyCoupon
} from "../chunk-NW3TT5X7.mjs";
import "../chunk-VPROHC3W.mjs";
import {
  useGetCities
} from "../chunk-UPHE75MB.mjs";
import "../chunk-6FSQB6YV.mjs";
import {
  useGetFaqsGroups
} from "../chunk-L2SZ2YYF.mjs";
import {
  useGetFaqByGroup,
  useGetFaqsList
} from "../chunk-MSO4PV43.mjs";
import "../chunk-RJ7PV2AC.mjs";
import {
  useContactUs
} from "../chunk-4X3U4DBT.mjs";
import "../chunk-X7CUQC4Y.mjs";
import {
  useGetSupportedCurrencies
} from "../chunk-LWQJX4OL.mjs";
import {
  useActivateDevice
} from "../chunk-OSCAKIZY.mjs";
import "../chunk-QIUKT56C.mjs";
import {
  useGetGeneratedPayment
} from "../chunk-23T55OPK.mjs";
import {
  useGetMarketingFees
} from "../chunk-XPLPC3IE.mjs";
import {
  useGetHyExperienceOrderById,
  useGetOrderById
} from "../chunk-J47NVHVO.mjs";
import {
  useAssignOrderSeats,
  useGetAssignSeatsData
} from "../chunk-JTAN757X.mjs";
import "../chunk-UF2ZH2HE.mjs";
import {
  useGetTopUpTransactionbyId
} from "../chunk-FZGGLAGR.mjs";
import {
  useGetUserDigitalCardById
} from "../chunk-5WJSAS37.mjs";
import {
  useGetUserDigitalCards
} from "../chunk-POTVB2ME.mjs";
import {
  useGetDigitalCards
} from "../chunk-FJQ6IZH5.mjs";
import {
  useTopUpCard
} from "../chunk-QMEBJCA6.mjs";
import "../chunk-FSCAG4CK.mjs";
import {
  useRemoveCartItem
} from "../chunk-LWE2O2DY.mjs";
import {
  useRemoveAllCartItems
} from "../chunk-RM6DZR76.mjs";
import {
  useApplePayPaymentProceed,
  useApplePayPaymentSession
} from "../chunk-CJYJQUKI.mjs";
import {
  useGetBluBookings,
  useGetBookings,
  useGetHyExperiencesBookings,
  useGetSeasonBookings
} from "../chunk-37L2MKWX.mjs";
import {
  useClaimOfflineOrder,
  useClaimOfflineOrderAndUpdateUser,
  useValidateOfflineOrderToken
} from "../chunk-PB4NVBIN.mjs";
import {
  useDownloadReceipt,
  useDownloadTicket
} from "../chunk-A2ERGUHF.mjs";
import {
  useSendOtpToFanId,
  useVerifyFanIdOtp
} from "../chunk-WAHIDM2L.mjs";
import {
  useAddToCart
} from "../chunk-WPTX4WTG.mjs";
import {
  useGetCartItems
} from "../chunk-554KRDR7.mjs";
import {
  useCheckoutCart
} from "../chunk-PYNXHVYD.mjs";
import "../chunk-JJDHBOQ6.mjs";
import {
  useBusiness
} from "../chunk-Z7SAOY4Q.mjs";
import "../chunk-2Z7D5UWA.mjs";
import {
  useUpdateProfile
} from "../chunk-JHUYVGJI.mjs";
import {
  useRefreshTokens
} from "../chunk-HSAIIPMN.mjs";
import {
  useRegister,
  useSignup
} from "../chunk-Y3XWJ7R7.mjs";
import {
  useGetTawakkalnaUser,
  useLinkTawakkalnaUser
} from "../chunk-WEJGTWV5.mjs";
import {
  useGetUser
} from "../chunk-ADO6ADI6.mjs";
import {
  useSendOtpToEmail,
  useUpdateEmail,
  useVerifyEmail
} from "../chunk-CTQJTBPV.mjs";
import {
  useLogin
} from "../chunk-EQJMIOEH.mjs";
import {
  useLogout
} from "../chunk-WUXG3FHL.mjs";
import {
  useSendOtp,
  useVerifyOtp
} from "../chunk-3CBN2GKU.mjs";
import {
  useChangePassword,
  useForgotPassword
} from "../chunk-4AF7IUJC.mjs";
import "../chunk-U5ODFYVI.mjs";
import {
  useCancelAccessibilityRequest
} from "../chunk-HSJWG5EJ.mjs";
import {
  useCreateAccessibilityRequest
} from "../chunk-WE55TZ5Q.mjs";
import {
  useGetAccessibilityRequests
} from "../chunk-AI7EGESH.mjs";
import {
  useRequestDisabilityTickets
} from "../chunk-IV2CAQT5.mjs";
import {
  useUpdateAccessibilityRequest
} from "../chunk-W5GJ4HJW.mjs";
import {
  useViewRequest
} from "../chunk-5AXTSY73.mjs";
import "../chunk-ND5RCKP6.mjs";
import {
  useGetAuctionSecureDeposit
} from "../chunk-YW3PKFK7.mjs";
import {
  useAddAddress
} from "../chunk-GRTFG6SJ.mjs";
import {
  useGetAuctionHistory
} from "../chunk-XB37LZRI.mjs";
import {
  useDidUserJoinedAuction
} from "../chunk-QMZ2H2UY.mjs";
import {
  useGetAuctionOrders
} from "../chunk-CDINRJN2.mjs";
import {
  useCheckoutAuctionPayment,
  useGetAuctionPaymentDetails
} from "../chunk-3JN7R6FT.mjs";
import "../chunk-NOHK3WEE.mjs";
import "../chunk-KEWTJQOK.mjs";
import {
  useBlogList
} from "../chunk-G23PCGQ3.mjs";
import "../chunk-FOJMTK4I.mjs";
import "../chunk-BKWZJPJV.mjs";
import {
  useGetExperiencesByCategory
} from "../chunk-3TUHMNQN.mjs";
import {
  useGetExperienceBySlug
} from "../chunk-3EOGSTVL.mjs";
import "../chunk-FXLMWHDY.mjs";
import {
  useVerifyHyCoupon
} from "../chunk-GFTHW6CE.mjs";
import "../chunk-7CPUYQCC.mjs";
import {
  useShopProducts
} from "../chunk-NSKRVOQU.mjs";
import "../chunk-YAFEA4GV.mjs";
import "../chunk-IWR3FJEY.mjs";
import "../chunk-FY4U22RN.mjs";
import "../chunk-IL34TLOI.mjs";
import "../chunk-N3FEOFTO.mjs";
import "../chunk-N6BMRVT6.mjs";
import "../chunk-TRVOCNJ2.mjs";
import "../chunk-IUSFARES.mjs";
import "../chunk-243MJCC7.mjs";
import "../chunk-B5QN6XKF.mjs";
import "../chunk-CI2OCWMM.mjs";
import "../chunk-ICBCJ4TF.mjs";
import "../chunk-WPQ4LM42.mjs";
import "../chunk-XNT4HZJE.mjs";
import "../chunk-4BR5LMYE.mjs";
import "../chunk-IY346L2T.mjs";
import "../chunk-6BBXH2HD.mjs";
import "../chunk-IKE7OJFM.mjs";
import "../chunk-ED2FEAOP.mjs";
import "../chunk-5QEPWO53.mjs";
import "../chunk-S5TFWWY6.mjs";
import "../chunk-4WXYMJKJ.mjs";
import "../chunk-BLYOJCCG.mjs";
import "../chunk-UYP7IFKD.mjs";
import "../chunk-ATY57U4J.mjs";
import "../chunk-2E3AVFHJ.mjs";
import "../chunk-G6HFKZYY.mjs";
import "../chunk-56VKBNTW.mjs";
import "../chunk-WKI5B7WG.mjs";
import "../chunk-RUHYBE6H.mjs";
import "../chunk-VEILD7LK.mjs";
import "../chunk-DFZR2I7T.mjs";
import "../chunk-L6RO57D4.mjs";
import "../chunk-NOGOGIPL.mjs";
import "../chunk-JDXYYHVO.mjs";
import "../chunk-ND3ZKELH.mjs";
import "../chunk-Z4Y3TSZF.mjs";
import "../chunk-CKUI3OOE.mjs";
import "../chunk-UYOVINKV.mjs";
import "../chunk-47V255NO.mjs";
import "../chunk-LULG3X63.mjs";
import "../chunk-5O4AMI3D.mjs";
import "../chunk-YHJAGYFE.mjs";
import "../chunk-SLPLQIPV.mjs";
import "../chunk-C7TBBAFE.mjs";
import "../chunk-KJ4BCIKR.mjs";
import "../chunk-XQSBA2MC.mjs";
import "../chunk-5LVNPPPJ.mjs";
import "../chunk-2EW6PRHF.mjs";
import "../chunk-LCP3DRRQ.mjs";
import "../chunk-Y5JN53D4.mjs";
import "../chunk-GT6BEZA2.mjs";
import "../chunk-PNXQD6TB.mjs";
import "../chunk-G4HYUTTV.mjs";
import "../chunk-SAJLN2Y4.mjs";
import "../chunk-HE64LB42.mjs";
import "../chunk-MNOETE5T.mjs";
import "../chunk-U5K6Y66M.mjs";
import "../chunk-OD644NCZ.mjs";
import "../chunk-YJRK7R47.mjs";
import "../chunk-3NIGQFVG.mjs";
import "../chunk-FFWHVCDR.mjs";
import "../chunk-5AZN4VUL.mjs";
import "../chunk-2YOAUMO3.mjs";
import "../chunk-4GTMVVYN.mjs";
import "../chunk-I4IIAVB4.mjs";
import "../chunk-RJZ32FXO.mjs";
import "../chunk-M53PCTWP.mjs";
import "../chunk-KCCMYIZJ.mjs";
import "../chunk-JI5U5XIQ.mjs";
import "../chunk-WEVSIQZA.mjs";
import "../chunk-Z3JXDCQ4.mjs";
import "../chunk-R57NLODR.mjs";
import "../chunk-HAFZFMEA.mjs";
import "../chunk-CLYATIFJ.mjs";
import "../chunk-CFW56QPS.mjs";
import "../chunk-5TOJXEQI.mjs";
import "../chunk-MGLDURDS.mjs";
import "../chunk-PGB6NIU4.mjs";
import "../chunk-VFGVMRC6.mjs";
import "../chunk-PWBDB2GM.mjs";
import "../chunk-5AG4OSVM.mjs";
import "../chunk-UGPJUWPT.mjs";
import "../chunk-SDH44CQK.mjs";
import "../chunk-RONAXZBM.mjs";
import "../chunk-LS6WDS7S.mjs";
import "../chunk-XXTSOKP4.mjs";
import "../chunk-VTN2NFFF.mjs";
import "../chunk-C73HCOEE.mjs";
import "../chunk-7D6VTW7J.mjs";
import "../chunk-X6YSHJ46.mjs";
import "../chunk-KER5PLWP.mjs";
import "../chunk-RU7JTQG6.mjs";
import "../chunk-UA2OFFNM.mjs";
import "../chunk-4WQ2W6UE.mjs";
import "../chunk-OZQE2SRZ.mjs";
import "../chunk-RNTDQTKT.mjs";
import "../chunk-PTP4T6YE.mjs";
import "../chunk-F4NAGWFB.mjs";
import "../chunk-AIITMJMT.mjs";
import "../chunk-AJAC64OP.mjs";
import "../chunk-GMQGCHMN.mjs";
import "../chunk-KERMTD33.mjs";
import "../chunk-WGGKDFOU.mjs";
import "../chunk-PAPA77UE.mjs";
import "../chunk-5WOYYZOX.mjs";
import "../chunk-TOY73C7L.mjs";
import "../chunk-IUF3UKAC.mjs";
import "../chunk-I7G65FQP.mjs";
import "../chunk-CYNOW4MI.mjs";
import "../chunk-VVUEFUKX.mjs";
import "../chunk-6EMQUAZN.mjs";
import "../chunk-D55SJ3BC.mjs";
import "../chunk-56QEENOZ.mjs";
import "../chunk-H3BAINZ7.mjs";
import "../chunk-HSA6GNMK.mjs";
import "../chunk-QTMZG7DB.mjs";
import "../chunk-7E2RCWKK.mjs";
import "../chunk-UHYUBKSS.mjs";
import "../chunk-DYHV6AVI.mjs";
import "../chunk-H2CYOPFA.mjs";
import "../chunk-NJMNBV76.mjs";
import "../chunk-E5UG324Z.mjs";
import "../chunk-Z65TGHIB.mjs";
import "../chunk-OIYYYWHS.mjs";
import "../chunk-H5NJJXVU.mjs";
import "../chunk-6ZAXXDHM.mjs";
import "../chunk-HAIBRHGD.mjs";
import "../chunk-CEO36EJ3.mjs";
import "../chunk-KSN6NPSV.mjs";
import "../chunk-3ZCKVQEX.mjs";
import "../chunk-4H5QH737.mjs";
import "../chunk-Z7ST37D5.mjs";
import "../chunk-Q4MQSBW7.mjs";
import "../chunk-JUTFKOEI.mjs";
import "../chunk-ILJZRPJP.mjs";
import "../chunk-FQRHG3M3.mjs";
import "../chunk-VRVENEGN.mjs";
import "../chunk-NKCMDZP6.mjs";
import "../chunk-PV5KIJUU.mjs";
import "../chunk-C7V6NFUL.mjs";
import "../chunk-FRQRMYBL.mjs";
import "../chunk-YO6XT5IM.mjs";
import "../chunk-IGEK7YQ4.mjs";
import "../chunk-ZLYIF74S.mjs";
import "../chunk-5F3MQQRO.mjs";
import "../chunk-5LQQRGFL.mjs";
import "../chunk-CH5VFPB2.mjs";
import "../chunk-MILZ6BWO.mjs";
import "../chunk-7UMPC2CN.mjs";
import "../chunk-TEC66KCK.mjs";
import "../chunk-RFZS4FD2.mjs";
import "../chunk-ME2YUJXI.mjs";
import "../chunk-J3KH27OL.mjs";
import "../chunk-QSNPBMYP.mjs";
import "../chunk-RLL65KCQ.mjs";
import "../chunk-S5YYOYM6.mjs";
import "../chunk-KTO4OUDO.mjs";
import "../chunk-ITD4VZXV.mjs";
import "../chunk-L3BNJCCQ.mjs";
import "../chunk-WIBPVKCY.mjs";
import "../chunk-V3CLW45A.mjs";
import "../chunk-U4523KN4.mjs";
import "../chunk-7GRJSXCB.mjs";
import "../chunk-PATOLGYV.mjs";
import "../chunk-OPXYQ7OH.mjs";
import "../chunk-B6TTHMBF.mjs";
import "../chunk-KQ56GOOB.mjs";
import "../chunk-JWMXWKBD.mjs";
import "../chunk-3LC557UY.mjs";
import "../chunk-LE6AHCLY.mjs";
import "../chunk-VY4OL5JD.mjs";
import "../chunk-BUCQGM24.mjs";
import "../chunk-JN6FEATO.mjs";
import "../chunk-TI7YS2GA.mjs";
import "../chunk-LCT2HWIT.mjs";
import "../chunk-YF67CDAZ.mjs";
import "../chunk-LACSACC3.mjs";
import "../chunk-IDB72OGF.mjs";
import "../chunk-NOYUIKST.mjs";
import "../chunk-5GBL5EYY.mjs";
import "../chunk-MUO3NQW7.mjs";
import "../chunk-JCLD5H3Q.mjs";
import "../chunk-HLL6YBIP.mjs";
import "../chunk-OT6P6L6K.mjs";
import "../chunk-HHLL3SNP.mjs";
import "../chunk-CBZI2JX3.mjs";
import "../chunk-7KZOUX5Z.mjs";
import "../chunk-XVHMV2MN.mjs";
import "../chunk-LQILT7DB.mjs";
import "../chunk-5OG6BFKZ.mjs";
import "../chunk-EB2U3AFA.mjs";
import "../chunk-SUWMYVYR.mjs";
import "../chunk-6PYILLDN.mjs";
import "../chunk-YCCRFFYC.mjs";
import "../chunk-LPVQMOLH.mjs";
import "../chunk-3XJMUV2F.mjs";
import "../chunk-OTZHFFCM.mjs";
import "../chunk-CBIK6ZLK.mjs";
import "../chunk-BDV7NIW4.mjs";
import "../chunk-AN6SOTHK.mjs";
import "../chunk-E34LUH6G.mjs";
import "../chunk-YWTSVXV6.mjs";
import "../chunk-HK6WBHFF.mjs";
import "../chunk-NMBT7PIE.mjs";
import "../chunk-YFYBARMO.mjs";
import "../chunk-NBJUG5HJ.mjs";
import "../chunk-FOJHN6HD.mjs";
import "../chunk-CLA7TQPO.mjs";
import "../chunk-IYHFO3U4.mjs";
import "../chunk-WWLG26XU.mjs";
import "../chunk-KRTSARJL.mjs";
import "../chunk-AQVZKKZU.mjs";
import "../chunk-5GTK3RJJ.mjs";
import "../chunk-LPIRJEMY.mjs";
import "../chunk-DFMI36TU.mjs";

// src/hooks/provider.tsx
import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { jsx, jsxs } from "react/jsx-runtime";
var localDefaults = {
  queries: {
    retry: 0,
    refetchOnWindowFocus: false
  },
  mutations: {
    retry: 0
  }
};
var QueryProvider = ({ children, defaults }) => {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: defaults || localDefaults })
  );
  return /* @__PURE__ */ jsxs(QueryClientProvider, { client: queryClient, children: [
    children,
    /* @__PURE__ */ jsx(ReactQueryDevtools, {})
  ] });
};
export {
  QueryProvider,
  useActivateDevice,
  useAddAddress,
  useAddToCart,
  useAddToThirdPartCart,
  useAirports,
  useAnswerSurvey,
  useApplePayPaymentProceed,
  useApplePayPaymentSession,
  useAssignOrderSeats,
  useBlogList,
  useBusiness,
  useCancelAccessibilityRequest,
  useCancelSubscription,
  useChangePassword,
  useCheckNafath,
  useCheckoutAuctionPayment,
  useCheckoutCart,
  useCheckoutStreamWithCredit,
  useCheckoutSubscription,
  useClaimOfflineOrder,
  useClaimOfflineOrderAndUpdateUser,
  useClaimSaudiRewards,
  useContactUs,
  useCreateAccessibilityRequest,
  useCreatePassenger,
  useDeletePassenger,
  useDidUserJoinedAuction,
  useDownloadHotelInvoice,
  useDownloadInvoice,
  useDownloadReceipt,
  useDownloadTicket,
  useEventsList,
  useEventsListByOrganizationSlug,
  useFareFamilies,
  useFlightsCheckout,
  useForgotPassword,
  useGeoLocation,
  useGetAccessibilityRequests,
  useGetAccessibilitySeason,
  useGetAccessibilityTicketingEvent,
  useGetAllPassengers,
  useGetAssignSeatsData,
  useGetAuctionHistory,
  useGetAuctionOrders,
  useGetAuctionPaymentDetails,
  useGetAuctionSecureDeposit,
  useGetBillingHistory,
  useGetBluBookings,
  useGetBookings,
  useGetCartItems,
  useGetCities,
  useGetDigitalCards,
  useGetEventAddonsById,
  useGetEventCrossSelling,
  useGetEventGroupBySlug,
  useGetEventPerks,
  useGetEventPrerequisiteTickets,
  useGetEventQuestions,
  useGetEventResaleTickets,
  useGetEventsGroupDetails,
  useGetExperienceBySlug,
  useGetExperiencesByCategory,
  useGetFaqByGroup,
  useGetFaqsGroups,
  useGetFaqsList,
  useGetFavoriteEvent,
  useGetFlightOrder,
  useGetFlightsOrders,
  useGetGeneratedPayment,
  useGetHoldToken,
  useGetHotelDetails,
  useGetHotelReservation,
  useGetHotelReservations,
  useGetHotelReviews,
  useGetHotelsResults,
  useGetHyExperienceOrderById,
  useGetHyExperiencesBookings,
  useGetInboundFlights,
  useGetInterestOptions,
  useGetLocationNotice,
  useGetMarketingFees,
  useGetMerchandiseProduct,
  useGetOrderById,
  useGetOrganizationBySlug,
  useGetOrganizations,
  useGetOrganizationsHasVouchers,
  useGetOutboundFlights,
  useGetPackageId,
  useGetPackageResults,
  useGetPassenger,
  useGetPaymentMethods,
  useGetResaleListing,
  useGetRoomDetails,
  useGetSeason,
  useGetSeasonBookings,
  useGetSeasonPerks,
  useGetSubscriptionActions,
  useGetSubscriptionById,
  useGetSubscriptionPlans,
  useGetSubscriptions,
  useGetSupportedCurrencies,
  useGetSurvey,
  useGetTawakkalnaUser,
  useGetTeam,
  useGetTeamEvents,
  useGetTeamsList,
  useGetTicketingEvent,
  useGetTicketingEventBlacklist,
  useGetTicketingEventSlots,
  useGetTicketingPackage,
  useGetTickets,
  useGetTopUpTransactionbyId,
  useGetTournamentDetails,
  useGetTournamentEventsBySlug,
  useGetTournamentOrganizationsBySlug,
  useGetTournamentTeamsBySlug,
  useGetTransactionById,
  useGetUser,
  useGetUserDigitalCardById,
  useGetUserDigitalCards,
  useGetUserEventLimits,
  useGetUserFavorites,
  useGetUserSubscriptions,
  useGetUserVouchers,
  useGetVenues,
  useGetVoucherPaymentDetails,
  useGetVouchers,
  useGetWalletHistory,
  useHoldProducts,
  useHotelsCheckout,
  useInitThirdPartCart,
  useLinkTawakkalnaUser,
  useLocations,
  useLogin,
  useLogout,
  useMerchandiseProducts,
  useModifySearch,
  useNearestAirport,
  usePaginatedEventsList,
  usePopularAirports,
  usePopularLocations,
  useRechargeWallet,
  useRedeemQitaf,
  useRefreshTokens,
  useRegister,
  useRegisterCompetition,
  useRegisterInterest,
  useRemoveAllCartItems,
  useRemoveCartItem,
  useRemoveFromThirdPartCart,
  useRequestDisabilityTickets,
  useRequestNafath,
  useReserveFlight,
  useResetPartnerUserPassword,
  useSearchFlights,
  useSearchHotels,
  useSelectedFlight,
  useSelectedPackage,
  useSendOtp,
  useSendOtpToEmail,
  useSendOtpToFanId,
  useSendPartnerOtp,
  useSendQitafOtp,
  useServmeShifts,
  useSevenRoomsAvailability,
  useSevenRoomsTables,
  useShopProducts,
  useSignup,
  useSubscribe,
  useSubscribeSaudiRewards,
  useTicketInterest,
  useToggleUserFavorite,
  useTopUpCard,
  useUpdateAccessibilityRequest,
  useUpdateEmail,
  useUpdateFavoriteTeam,
  useUpdatePassenger,
  useUpdateProfile,
  useUpdateUserInterests,
  useValidateOfflineOrderToken,
  useValidatePartnerEnc,
  useVerifyCoupon,
  useVerifyEmail,
  useVerifyFanIdOtp,
  useVerifyHyCoupon,
  useVerifyOtp,
  useVerifyPartnerOtp,
  useVerifyPartnerPasswordResetToken,
  useVerifySaudiRewards,
  useViewRequest
};
//# sourceMappingURL=index.mjs.map